import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { AddWhiteIcon, CleanIcon, EditIcon, TrashIcon, ChangeStatusIcon, TicketIcon } from 'assets/icons';
import { Pagination, Table, Input, Modal } from 'components';
import { ComboService } from 'services';
import ModalCreateCombo from './modal-create-combo';
import ModalViewCombo from './modal-view-combo';
import { Globals, Constants, checkPermission } from 'utils';
import { Tooltip } from 'components';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Combos extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nombre',
			'Precio de Venta',
			'Productos Incluidos',
			'Estatus',
			'Acciones'
		],
		visible: false,
		visible_view: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Combos de Productos',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await ComboService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.products.rows,
			last_page: res.products.count
		});
	}	

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	onCloseView = () => {
		this.setState({
			visible_view: false,
			item: null
		});
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	delete = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm('¿Desea eliminar el combo?',async () => {
			await ComboService.admin.delete({
				product_id: item.id
			});
			this.load(true);
		});
	}

	changeStatus = (e: any, item: any) => {
		e.preventDefault();
		Globals.confirm(`¿Desea ${ item.status == Constants.PRODUCT_STATUS.ACTIVE ? 'Desactivar' : 'Activar' } el combo?`,async () => {
			await ComboService.admin.changeStatus({
				product_id: item.id
			});
			this.load(true);
		});
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			item,
			visible: true
		});
	}
	
	render() {
		const { visible, visible_view } = this.state;

		return (
			<div id="admin-shop-combos">
				<Modal
		          className="modal-create-combo"
		          visible={ visible }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onClose() }
		        >
					<ModalCreateCombo
						title={ `${ this.state.item != null ? 'Editar' : 'Crear' } combo` }
						item={ this.state.item }
						onClose={ () => this.onClose() }
					/>
		      	</Modal>

		      	<Modal
		          className="modal-view-combo"
		          visible={ visible_view }
		          title=""
		          centered
		          withoutClose={ true }
		          onClose={ () => this.onCloseView() }
		        >
					<ModalViewCombo
						item={ this.state.item }
						onClose={ () => this.onCloseView() }
					/>
		      	</Modal>

				<BackComponent />

				<div className="row row-filter">
					<div className="col-md-8">
						<div className="row">
							<div className="col-md-5">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Nombre del combo"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-4 text-right">
						{
							checkPermission(Constants.MODULES.COMBOS,'write') && (
								<button className="btn btn-add" onClick={ () => this.add() }>
									<img src={ AddWhiteIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i.name }</td>
								<td>{ Globals.formatMiles(i?.price) }</td>
								<td>
									<button className="btn-ticket" onClick={ () => {
										this.setState({
											visible_view: true,
											item: i
										});
									} }>
										<img src={ TicketIcon } />
									</button>
								</td>
								<td>{ i.status_text }</td>
								<td>
									{
										checkPermission(Constants.MODULES.COMBOS,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.COMBOS,'write') && (
											<Tooltip title={ i.status == Constants.DISCOUNT_STATUS.ACTIVE ? 'Desactivar' : 'Activar' }>
												<a className="link-icon" href="#" onClick={ (e: any) => this.changeStatus(e,i) }>
													<img src={ ChangeStatusIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.COMBOS,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.delete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(Combos);